import React, { useEffect } from "react";
import { useUserAgent } from "../../hooks/useUserAgent";
import { Message } from "semantic-ui-react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getAppDownloadLinks } from "../../queries/communications";
import network from "../../selectors/network";
import { useSelector } from "react-redux";

import "../../features/notifcations/components/public_view_preview.scss";

import MobileStoreLinks from "../../features/notifcations/components/MobileStoreLinks";

export function PublicMobileAppDownloadPage() {
  const { site } = useParams<{ site: string }>();
  const networkHeaders = useSelector(network.defaultHeaders);
  const { isGoMobile, isAndroid, isIOS, isDesktop } = useUserAgent();
  const { data: downloadLinks, isLoading: isDownloadLinksLoading } = useQuery<{
    appleLink?: string;
    googleLink?: string;
  }>(["mobileDownloadLinks", site], getAppDownloadLinks(networkHeaders));

  useEffect(() => {
    if (isGoMobile) return;
    if (!downloadLinks) return;

    // Redirect to the appropriate app store
    if (isAndroid && downloadLinks.googleLink) window.location.replace(downloadLinks.googleLink);
    if (isIOS && downloadLinks.appleLink) window.location.replace(downloadLinks.appleLink);
  }, [downloadLinks, isAndroid, isIOS, isGoMobile]);

  if (isDownloadLinksLoading) return null;

  const showGoMobileMessage = isGoMobile;
  const showAndroidRedirectMessage = isAndroid && downloadLinks?.googleLink && !isGoMobile;
  const showIOSRedirectMessage = isIOS && downloadLinks?.appleLink && !isGoMobile;
  const showDesktopMessage = isDesktop;

  return (
    <div className='tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center'>
      {showGoMobileMessage && (
        <Message error>
          <Message.Header>Oops...</Message.Header>
          <Message.Content>
            This page cannot be viewed in the GoMobile app. Please visit this page in a web browser.
          </Message.Content>
        </Message>
      )}
      {showAndroidRedirectMessage && (
        <Message>
          <Message.Header>Redirecting you to the Play Store</Message.Header>
          <Message.Content>
            If you are not redirected, click <a href={downloadLinks.googleLink}>here</a>.
          </Message.Content>
        </Message>
      )}
      {showIOSRedirectMessage && (
        <Message>
          <Message.Header>Redirecting you to the App Store</Message.Header>
          <Message.Content>
            If you are not redirected, click <a href={downloadLinks.appleLink}>here</a>.
          </Message.Content>
        </Message>
      )}
      {showDesktopMessage && (
        <MobileStoreLinks appStoreHref={downloadLinks?.appleLink} googlePlayStoreHref={downloadLinks?.googleLink} />
      )}
    </div>
  );
}
